import { createContext, useContext, useState } from "react";

const TicketContext = createContext();

export function TicketProvider({ children }) {
  const [tickets, setTickets] = useState({
    promo: 0,
    adult: 0,
    child: 0,
  });

  const prices = {
    promo: 86, // Цена за промо-билет (2 взрослых + 1 ребенок)
    adult: 43,
    child: 31,
  };

  const totalTickets = tickets.promo + tickets.adult + tickets.child;
  const totalPrice =
    tickets.promo * prices.promo +
    tickets.adult * prices.adult +
    tickets.child * prices.child;

  return (
    <TicketContext.Provider value={{ tickets, setTickets, totalTickets, totalPrice }}>
      {children}
    </TicketContext.Provider>
  );
}

export function useTickets() {
  return useContext(TicketContext);
}
